import { app } from '../../utils/store';

export default class Search {
    constructor() {
        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu'),
        }

        this.search = {
            toggler: document.getElementById('search-toggler'),
            main: document.getElementById('search'),
        }

        this.minicart = {
            toggler: document.getElementById('cart'),
            main: document.getElementById('minicart'),
        };

        this.header = document.querySelector('header');
        this.body = document.querySelector('body');
    }

    init() {
        this.toggle();
        // if(!Sniff.features.mobile){ this.language(); }
    }

    toggle = () => {
        if (this.search.toggler) {
            this.search.toggler.addEventListener('click', () => {
                this.header.classList.add('search-active');
                // If Mobile > <body> == overflow:hidden
                if(Sniff.features.mobile){
                    if(this.body.classList.contains('overflow-hidden')){
                        this.body.classList.remove('overflow-hidden')
                    } else {
                        this.body.classList.add('overflow-hidden')
                    }
                }

                this.search.toggler.classList.toggle('active');
                this.search.main.classList.toggle('active');
                // Minicart De-activation
                this.minicart.toggler.classList.remove('active');
                this.minicart.main.classList.remove('active');
                // Menu De-activation
                this.menu.toggler.classList.remove('active');
                this.menu.main.classList.remove('active');

                app.overlay.classList.toggle('active');
            });
        }

        // if(this.search.main.classList.contains('active')){
        //     this.search.main.classList.remove('active');
        //     app.overlay.classList.remove('active');
        // }
    }
}
